import React from "react";

const MoreVertIcon = () => (
  <svg width="4" height="14" viewBox="0 0 4 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.00004 3.66665C2.91671 3.66665 3.66671 2.91665 3.66671 1.99998C3.66671 1.08331 2.91671 0.333313 2.00004 0.333313C1.08337 0.333313 0.333374 1.08331 0.333374 1.99998C0.333374 2.91665 1.08337 3.66665 2.00004 3.66665ZM2.00004 5.33331C1.08337 5.33331 0.333374 6.08331 0.333374 6.99998C0.333374 7.91665 1.08337 8.66665 2.00004 8.66665C2.91671 8.66665 3.66671 7.91665 3.66671 6.99998C3.66671 6.08331 2.91671 5.33331 2.00004 5.33331ZM2.00004 10.3333C1.08337 10.3333 0.333374 11.0833 0.333374 12C0.333374 12.9166 1.08337 13.6666 2.00004 13.6666C2.91671 13.6666 3.66671 12.9166 3.66671 12C3.66671 11.0833 2.91671 10.3333 2.00004 10.3333Z" fill="#69687A"/>
  </svg>
);

export default MoreVertIcon;
